import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import ToolDescription from './ToolDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BounceToolsContent = ({
  hasIlsListsWriteScope,
  onHardBounceListCreateClick,
  showMissingIlsListScopeTooltip,
  staticListLimitReached
}) => {
  const disabled = !hasIlsListsWriteScope || staticListLimitReached;
  return /*#__PURE__*/_jsx(UIList, {
    children: showMissingIlsListScopeTooltip( /*#__PURE__*/_jsxs(UIButton, {
      "data-test-id": "create-hard-bounces-button",
      disabled: disabled,
      onClick: onHardBounceListCreateClick,
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "EmailComponents.manage.moreTools.createHardBounceList"
      }), /*#__PURE__*/_jsx(ToolDescription, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.manage.moreTools.createHardBounceListDescription"
        })
      })]
    }), true)
  });
};
export default BounceToolsContent;